import React, {memo} from 'react';
import {SelectOption} from "../types/SelectOption";
import {Select, Option} from "@material-tailwind/react";

interface MaterialSelectType {
    placeholder: string,
    name: string,
    options: SelectOption[],
    required?: boolean,
    className?: string,
    relativeClassName?: string,
    onChange?: (key: string, value: string | number) => void,
    value?: string | number,
}

const MaterialSelect = React.forwardRef(({placeholder, name, options, onChange, value}: MaterialSelectType) => {
    const onLocalChange = (vl: string | undefined) => {
        if (onChange) {
            onChange(name, vl ?? '');
        }
    }

    return (
        <div className="flex flex-col gap-6">
            <Select className="dark:border-gray-800 dark:before:border-gray-800" variant="outlined" key={name}
                    label={placeholder}
                    onChange={onLocalChange}
                    value={value?.toString()}
                    selected={(element) =>
                element &&
                React.cloneElement(element, {
                    disabled: true,
                    className:
                        "flex items-center opacity-100 px-0 gap-2 pointer-events-none truncated pr-4 dark:text-white",
                })
            }>
                {options.map((value) => <Option key={`${value.name}-${value.id}`}
                                                value={value.id.toString()}>{value.name}</Option>)}
            </Select>
        </div>
    );

});
MaterialSelect.displayName = 'MaterialSelect';

export default memo(MaterialSelect);
